import { render, staticRenderFns } from "./control5Privateletter.vue?vue&type=template&id=3c7b7b00&scoped=true&"
import script from "./control5Privateletter.vue?vue&type=script&lang=js&"
export * from "./control5Privateletter.vue?vue&type=script&lang=js&"
import style0 from "./control5Privateletter.vue?vue&type=style&index=0&id=3c7b7b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b7b00",
  null
  
)

export default component.exports